class QubeStickyCart extends HTMLElement {
  constructor() {
    super();
    this.stickyCart = this.querySelector('.qube-sticky-cart');
    this.stickyBtn = this.querySelector('.qube-sticky-cart__btn');
    
    // Find the main product form submit button and the GoKwik buy now button
    this.mainSubmitBtn = document.querySelector('.product-form__submit');
    this.gokwikBtn = document.querySelector('#gokwik-buy-now');

    this.bindEvents();
    
    // Since the request was to be "active every time", we can just show it immediately,
    // or we can show it when scrolled past the main button. 
    // Let's show it immediately with a small delay for animation.
    setTimeout(() => {
      if (this.stickyCart) {
        this.stickyCart.classList.add('is-active');
      }
    }, 500);
  }

  bindEvents() {
    if (this.stickyBtn) {
      this.stickyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        
        // If GoKwik buy now button exists, click it. Otherwise, click standard add to cart.
        if (this.gokwikBtn && !this.gokwikBtn.disabled) {
          this.gokwikBtn.click();
        } else if (this.mainSubmitBtn && !this.mainSubmitBtn.disabled) {
          this.mainSubmitBtn.click();
        } else {
          console.warn('No active main checkout button found to forward the click to.');
        }
      });
    }
  }
}

customElements.define('qube-sticky-cart', QubeStickyCart);
